




















































import Vue from "vue";
import Snackbar from "./Snackbar.vue";
import { getUser } from "../utils/apiRequests";

export default Vue.extend({
  name: "loginform",
  components: { Snackbar },
  data: () => ({
    loading: false,
    snackbarText: "",
    snackbarColor: "",
    snackbar: false,
    valid: false,
    username: "",
    usernameRules: [
      (v: string) => !!v || "Username is required"
      // (v: string) =>
      //   (v && v.length >= 3) || "Username must be at least 3 characters"
    ],
    password: "",
    passwordRules: [
      (v: string) => !!v || "Password is required"
      // (v: string) =>
      //   (v && v.length >= 5) || "Password must be at least 5 characters"
    ]
  }),
  methods: {
    async handleLoginClick() {
      if ((<any>this.$refs.loginform).validate()) {
        this.loading = true;
        const response = await getUser(this.username, this.password);
        if (response.success) {
          this.loading = false;
          this.showAndHideSnackbar(response.msg, "info", 2000);
          setTimeout(() => {
            this.$router.push({
              name: "game",
              params: { user: response.user, loggedIn: "true", auth: response.auth }
            });
          }, 3000);
        } else {
          this.loading = false;
          this.showAndHideSnackbar(response.msg, "error", 3000);
          return;
        }
      }
    },
    handleResetClick() {
      (<any>this.$refs.loginform).reset();
    },
    showAndHideSnackbar(message: string, color: string, duration: number) {
      this.snackbarText = message;
      this.snackbarColor = color;
      this.snackbar = true;
      setTimeout(() => {
        this.snackbar = false;
      }, duration);
    }
  },
  mounted() {
    if (this.$route.params.msg) {
      this.showAndHideSnackbar(this.$route.params.msg, "info", 3000);
    }
  }
});
